export const fallbackLang = 'en'
export const allLanguages = [
  'en', // English
  'ar', // Arabic
  'bn', // Bengali
  'fr', // French
  'sw', // Swahili
  'es', // Spanish
  'pt', // Portuguese
  'it', // Italian
  'ru', // Russian
  'fa', // Farsi
  'vi', // Vietnamese
  'nl', // Dutch
  'de', // German
  'pl', // Polish
  'sv', // Swedish
  'id', // Indonesian
  'tr', // Turkish
  'ms', // Malay
  'hi', // Hindi
  'zh', // Chinese
  'fil', // Filipino
  'th', // Thau
  'uk', // Ukranian
  'fas', // Persian
  'or', // Oriya
  'kn', // Kannada
  'mr', // Marathi
  'gu', // Gujarati
  'te', // Telugu
  'ta', // Tamil
  'ml', // Malayalam
  'pt-br', // Portuguese (Brazil)
] as const

export const supportedLanguages = [
  'en',
  'hi',
  'es',
  'fr',
  'ar',
  'pt',
  'ru',
  'de',
  'te',
  'ta',
  'vi',
  'kn',
  'or',
  'pt-br',
] as const

export type LanguageCodes = (typeof allLanguages)[number]

export const languageCookieName = 'gzp-lang'
export const defaultNS = 'translation'

export function getOptions(lng = fallbackLang, ns = 'common') {
  return {
    // debug: true,
    supportedLngs: allLanguages,
    fallbackLng: fallbackLang,
    lng,
    fallbackNS: defaultNS,
    defaultNS,
    ns,
  }
}
